__webpack_require__.v = (exports, wasmModuleId, wasmModuleHash, importsObj) => {

	var req = fetch(__webpack_require__.p + "" + wasmModuleHash + ".wasm");
	var fallback = () => (req
		.then((x) => (x.arrayBuffer()))
		.then((bytes) => (WebAssembly.instantiate(bytes, importsObj)))
		.then((res) => (Object.assign(exports, res.instance.exports))));
	return req.then((res) => {
		if (typeof WebAssembly.instantiateStreaming === "function") {

			return WebAssembly.instantiateStreaming(res, importsObj)
				.then(
					(res) => (Object.assign(exports, res.instance.exports)),
					(e) => {
						if(res.headers.get("Content-Type") !== "application/wasm") {
							console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
							return fallback();
						}
						throw e;
					}
				);
		}
		return fallback();
	});
};